
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';

interface FreePlanBannerProps {
  daysRemaining: number;
}

export function FreePlanBanner({ daysRemaining }: FreePlanBannerProps) {
  const navigate = useNavigate();
  
  // Define the message and styling based on days remaining
  let message = '';
  let urgencyClass = '';
  
  if (daysRemaining <= 1) {
    message = 'Your Free plan expires today!';
    urgencyClass = 'bg-orange-100 border-orange-300 text-orange-800';
  } else if (daysRemaining <= 3) {
    message = `Your Free plan expires in ${daysRemaining} days.`;
    urgencyClass = 'bg-blue-100 border-blue-300 text-blue-800';
  } else {
    message = `You have ${daysRemaining} days left on your Free plan.`;
    urgencyClass = 'bg-green-100 border-green-300 text-green-800';
  }
  
  return (
    <div className={`mb-4 px-4 py-3 rounded-md border flex items-center justify-between ${urgencyClass}`}>
      <div className="flex items-center">
        <Clock className="h-5 w-5 mr-2" />
        <span className="text-sm font-medium">{message}</span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={() => navigate('/subscription/plans')}
        className="ml-2 whitespace-nowrap bg-white hover:bg-gray-50"
      >
        Upgrade Now
      </Button>
    </div>
  );
}
